import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import difference from 'lodash/difference';
import { Form, FieldArray, withFormik } from 'formik';
import * as Yup from 'yup';
import { Prompt } from 'react-router-dom';
import { Input } from '../../components/Form/Input';
import { Dropdown } from '../../components/Form/Dropdown';
import { CheckboxGroup } from '../../components/Form/CheckboxGroup';
import { Button } from '../Button';
import { Regex } from '../../shared/helpers';
import { Thumbnail } from '../Thumbnail';
import './FreelancerPortfolioForm.css';

const checkboxes = [
  'Pre Production',
  'Editing',
  'Production',
  'Color Correction',
  'Animation',
  'Sound Design',
  'Other(s)',
];

const getCheckbox = checkbox => ({ value: checkbox });

const getCheckboxWithInput = (checkbox, skills) => ({
  value: checkbox,
  defaultValue: difference(skills, checkboxes)[0],
  withInput: true,
});

const getCheckboxes = skills =>
  map(
    checkboxes,
    checkbox =>
      checkbox === 'Other(s)'
        ? getCheckboxWithInput(checkbox, skills)
        : getCheckbox(checkbox),
  );

const renderForm = submissions =>
  submissions.map(({ skills, video_link: videoLink }, index) => (
    <div className="row" key={String(index)}>
      <div className="col-12 col-md-5">
        <div className="row">
          <div className="col-12">
            <Thumbnail
              src={videoLink}
              alt="video thumbnail"
              className="w-100 mb-3"
              defaultSrc="https://i.vimeocdn.com/video/674803523.jpg?mw=344&mh=194"
              defaultVideoSrc="https://i.vimeocdn.com/video/674803523.jpg?mw=344&mh=194"
            />
          </div>
          <div className="col-12">
            <CheckboxGroup
              titleClassName="portfolio-form__card__checkbox-fields-title"
              fieldsClassName="portfolio-form__card__checkbox-fields"
              checkboxContainerClassName="portfolio-form__card__checkbox"
              checkboxInputClassName="portfolio-form__card__checkbox--input"
              inputClassName="portfolio-form__card__checkbox__input"
              name={`submissions.${index}.skills`}
              title="Applied Skills"
              fields={getCheckboxes(skills)}
            />
          </div>
        </div>
      </div>
      <div className="col-12 col-md">
        <Input
          fluid
          containerClassName="portfolio-form__card__input"
          labelClassName="portfolio-form__card__input-label"
          name={`submissions.${index}.clip_name`}
          label="Clip Name"
        />
        <Input
          fluid
          containerClassName="portfolio-form__card__input"
          labelClassName="portfolio-form__card__input-label"
          name={`submissions.${index}.video_link`}
          label="Video Link"
        />
        <div className="col-12 col-md mb-3">
          <Dropdown
            containerClassName="as"
            labelClassName="portfolio-form__card__input-label"
            name={`submissions.${index}.contribution_level`}
            label="Contribution Level"
            options={[
              {
                key: 'sole_contributor',
                text: 'Sole Contributor',
                value: 'sole_contributor',
              },
              {
                key: 'partial_contributor',
                text: 'Partial Contributor',
                value: 'partial_contributor',
              },
            ]}
          />
        </div>
        <Input
          fluid
          inputClassName="portfolio-form__card__input-text-area"
          labelClassName="portfolio-form__card__input-label"
          name={`submissions.${index}.comments`}
          type="textArea"
          label="Comments"
          placeholder="Describe your contributions in this video..."
        />
      </div>
    </div>
  ));

const FreelancerPortfolioForm = ({ values, dirty, isValid }) => (
  <Fragment>
    <Prompt
      when={dirty}
      message="You have unsaved changes, are you sure you want to leave?"
    />
    <Form className="portfolio-form px-5 py-3">
      <FieldArray
        name="submissions"
        render={() => (
          <div className="portfolio-form__array">
            {values.submissions &&
              values.submissions.length > 0 &&
              renderForm(values.submissions)}
            <Button
              className="px-4 mt-2"
              type="submit"
              disabled={!dirty || !isValid}
              rounded
              title="Save"
            />
          </div>
        )}
      />
    </Form>
  </Fragment>
);

FreelancerPortfolioForm.propTypes = {
  values: PropTypes.shape({
    submissions: PropTypes.array,
  }),
  dirty: PropTypes.bool,
  isValid: PropTypes.bool,
};

const submissionsInitialValues = [
  {
    clip_name: '',
    video_link: '',
    contribution_level: '',
    comments: '',
    skills: [],
  },
];

const mapPropsToValues = props => ({
  submissions: !isEmpty(props.submissions)
    ? props.submissions
    : submissionsInitialValues,
});

const validationSchema = Yup.object().shape({
  submissions: Yup.array().of(
    Yup.object().shape({
      clip_name: Yup.string().required('Clip Name is Required'),
      video_link: Yup.string()
        .matches(Regex.site, 'Video Link is invalid')
        .required('Video Link is Required'),
    }),
  ),
});

export default withFormik({
  handleSubmit: (values, { props, resetForm }) =>
    props.onSubmit && props.onSubmit(values, resetForm),
  enableReinitialize: true,
  isInitialValid: props =>
    validationSchema.isValidSync(mapPropsToValues(props)),
  mapPropsToValues,
  validationSchema,
  displayName: 'FreelancerPortfolioForm',
})(FreelancerPortfolioForm);



// WEBPACK FOOTER //
// ./src/components/FreelancerPortfolioForm/FreelancerPortfolioForm.js